import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import gallery_img from "../assets/gallery/g-top.jpg";
import Img from "../comps/Img";
import Pagebreak from "../comps/Pagebreak";
import PageTop from "../comps/PageTop";
import "../styles/Gallery.scss";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { FaDownload, FaShareAlt,FaTimes  } from "react-icons/fa";

function Gallery(props) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const targetRef = useRef(null);
  function handleLoading() {
    setVisibleImages(visibleImages + 1);
  }

  const [Image, setImages] = useState([]);
  const fetchImages = async () => {
    try {
      props.setLoader(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}Gallery/getallGalleries`,
      );

      const imagesData = response.data.map((item) => item.data);
      const formattedImages = imagesData.map((data) => ({ image: data.image }));
      setImages(formattedImages);
    } catch (error) {
      console.log(error);
    } finally {
      props.setLoader(false);
    }
  };
  const slides = Image.map((item) => ({
    src: item.image,
  }));

  const a1 = [];
  const a2 = [];
  const a3 = [];

  for (let i = 0; i < Image.length; i++) {
    if (i % 3 === 0) {
      a1.push(Image[i]);
    } else if (i % 3 === 1) {
      a2.push(Image[i]);
    } else {
      a3.push(Image[i]);
    }
  }

  const [visibleImages, setVisibleImages] = useState(2);
  useEffect(() => {
    fetchImages();
  }, []);

  const openLightbox = (index) => {
    setIndex(index);
    setOpen(true);
  };
  return (
    <>
      <PageTop img={gallery_img} title="Gallery" />
      <Pagebreak greyBreakPage={true} />
      <div className="gallery-grid-parent parent bg-img-cover">
        <div className="gallery-grid-cont cont">
          <div className="row1 row">
            {a1.slice(0, visibleImages).map((item) => {
              const realIndex = Image.indexOf(item);
              return (
                <Img
                  key={realIndex}
                  imgurl={item.image}
                  click={() => {
                    setIndex(realIndex);
                    setOpen(true);
                  }}
                />
              );
            })}
          </div>

          <div className="row2 row">
            {a2.slice(0, visibleImages).map((item) => {
              const realIndex = Image.indexOf(item);
              return (
                <Img
                  key={realIndex}
                  imgurl={item.image}
                  click={() => {
                    setIndex(realIndex);
                    setOpen(true);
                  }}
                />
              );
            })}
          </div>

          <div className="row3 row">
            {a3.slice(0, visibleImages).map((item) => {
              const realIndex = Image.indexOf(item);
              return (
                <Img
                  key={realIndex}
                  imgurl={item.image}
                  click={() => {
                    setIndex(realIndex);
                    setOpen(true);
                  }}
                />
              );
            })}
          </div>
        </div>

        {visibleImages < a1.length && (
          <button
            onClick={() => handleLoading()}
            className="btn loadmore-btn load-more"
          >
            {" "}
            Load More
          </button>
        )}

        <div ref={targetRef}></div>
      </div>
      {open && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={index}
          toolbar={{
            buttons: [
              <button
                key="download"
                className="btn"
                style={{ marginRight: "10px" }}
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = slides[index].src;
                  link.download = "image";
                  link.click();
                }}
              >
                <FaDownload />
              </button>,

              <button
                key="share"
                className="btn"
               style={{ marginRight: "10px" }}
                onClick={() => {
                  navigator.clipboard.writeText(slides[index].src);
                  alert("Image link copied!");
                }}
              >
                <FaShareAlt />
              </button>,
              <button
              //  style={{ marginRight: "60px" }}
                key="close"
                className="btn"
                onClick={() => setOpen(false)}
              >
                <FaTimes />
              </button>,
            ],
          }}
        />
      )}
    </>
  );
}

export default Gallery;
